import { DateTime } from 'luxon';

const DEFAULT_UNITS = ['days', 'hours', 'minutes', 'seconds'];

function parseDateTime(value) {
  if (!value) {
    return null;
  }

  const dateTime = DateTime.isDateTime(value) ? value : DateTime.fromISO(value);
  return dateTime.isValid ? dateTime : null;
}

// Returns a human-readable duration between two datetimes (e.g. "2m 14s", "1h").
export function formatDateTimeDifference(start, end, { alwaysShowSeconds = false, units = DEFAULT_UNITS } = {}) {
  const startDateTime = parseDateTime(start);
  const endDateTime = parseDateTime(end);

  if (!startDateTime || !endDateTime) {
    return '';
  }

  const totalSeconds = Math.max(0, Math.floor(endDateTime.diff(startDateTime, 'seconds').seconds));
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const parts = [];

  if (units.includes('days') && days) {
    parts.push(`${days}d`);
  }
  if (units.includes('hours') && hours) {
    parts.push(`${hours}h`);
  }
  if (units.includes('minutes') && minutes) {
    parts.push(`${minutes}m`);
  }
  if (units.includes('seconds') && (alwaysShowSeconds || seconds || parts.length === 0)) {
    parts.push(`${seconds}s`);
  }

  return parts.join(' ');
}
